<template>
    <v-dialog v-bind:value="value" width="600px">
        <v-card>
            <v-card-title>
                <img :src="getFlag('it-flag.png')" alt="informazioni covid-19" width="25px" class="mr-3">
                <span class="headline">INFORMAZIONI COVID-19</span>
                
                <v-spacer></v-spacer>
                <v-icon @click="$emit('close')">fas fa-times</v-icon>
            </v-card-title>

            <v-card-text>
                <p>
                    In questo momento di difficoltà sanitaria che stiamo vivendo, vogliamo innanzitutto ringraziarti per la fiducia che ci riservi e comunicarti che abbiamo attuato una serie di misure per garantirti un soggiorno sicuro e accogliente.
                </p>
                <p>
                    In linea con il <a target="_blank" href="https://www.federalberghi.it/comunicati/hotel-al-tempo-del-covid-protocollo-nazionale-accoglienza-sicura.aspx">protocollo nazionale “Accoglienza sicura”</a> stilato da Federalberghi per la prevenzione da Covid-19 nelle strutture ricettive e nel rispetto delle <a target="_blank" href="http://pti.regione.sicilia.it/portal/page/portal/PIR_PORTALE/PIR_Covid19OrdinanzePresidenzadellaRegione/ordinanza-21-17052020.pdf">linee guida emanate dalla Regione Sicilia</a>, ti riportiamo di seguito le nostre misure di prevenzione:
                </p>
                <p>
                    <ul>
                        <li> Frequente sanificazione di tutti i locali della struttura: camere, aree comuni, punti di contatto (maniglie, pulsanti, interruttori etc)</li>
                        <li> Pulizia e sanificazione giornaliera delle camere durante il soggiorno attraverso il personale istruito e dotato dei dispositivi di protezione individuale e adeguati prodotti igienico-sanitari.</li>
                        <li> Pulizia filtri ed impianti di condizionamento</li>
                        <li> Postazione con gel disinfettante all’ingresso del B&B</li>
                        <li> Biancheria trattata da lavanderia industriale certificata per uso sanitario</li>
                        <li> Personale sempre provvisto di mascherina e visiera</li>
                        <li> Obbligo di uso della mascherina per tutti gli ospiti all’interno delle aree comuni</li>
                        <li> Delimitazione di spazi con adesivi segna-percorso</li>
                        <li> Cartelli informativi </li>
                        <li> Dotazione di maschere e guanti per gli ospiti su richiesta</li>
                        <li> Dotazione in camera di gel monodose e kit pulizie per gli ospiti che volessero pulire autonomamente la propria camera durante il soggiorno o all’arrivo.</li>
                        <li> Involucro plastificato per copertura telecomandi in camera (usa e getta ad ogni cambio camera).</li>
                    </ul>
                </p>
                <p>
                    Alcuni extra comfort per te:
                    <ul>
                        <li>Ti garantiamo il self check-in con codice di accesso e scheda magnetica per darti la possibilità di accedere alla struttura «contact-less»; </li>
                        <li>colazione in camera o presso bar convenzionato sito a lato del nostro ingresso (disponibile anche colazione a sacco).</li>
                        <li>Digitalizziamo la maggior parte dei nostri servizi, inclusa la nostra assistenza: puoi contattarci con chiamata, WhatsApp, messaggio per qualsiasi necessità!</li>
                        <li>Ti garantiamo il self check-out, puoi lasciare liberamente la struttura senza passare dalla reception per le pratiche di check-out.</li>
                    </ul>
                </p>

                <v-divider class="px-1" />

                <p class="mt-4">
                    <img :src="getFlag('uk-flag.jpg')" alt="informazioni covid-19" width="25px" class="mr-3">
                    <span class="headline">COVID-19 INFORMATION</span>
                </p>

                <p>
                    In this difficult moment for global health that we are experiencing, we first of all want to thank you for the trust reserved and take the opportunity to inform you that we have implemented a series of measures to ensure you a safe and welcoming stay.
                </p>

                <p>
                    Following the national protocol "Safe reception" drawn up by Federalberghi Association for the prevention of Covid-19 in accommodation facilities and according with the guidelines issued by sicilian and national authorities, we report below our prevention measures:
                </p>

                <p>
                    <ul>
                        <li>Frequent sanitization of the whole B&B: bedrooms, common areas, contact points (handles, buttons, switches, etc.)</li>
                        <li>Daily cleaning and sanitizing of the rooms during the stay through trained personnel equipped with individual protection devices and hygienic-sanitary products.</li>
                        <li>Cleaning of filters and air conditioning systems</li>
                        <li>Station with disinfectant gel at the entrance of the B&B</li>
                        <li>Linen treated for industrial laundry certified for sanitary use</li>
                        <li>Staff always equipped with mask and visor</li>
                        <li>It is mandatory for all guests to wear a face mask within the common areas</li>
                        <li>Delimitation of spaces with path marker stickers</li>
                        <li>Information signs</li>
                        <li>equipment of masks and gloves for guests on request</li>
                        <li>Single-dose gel in the room and cleaning kit for guests who want to independently clean their room during their stay or at their arrival.</li>
                        <li>Plastic casing to cover the remote controls in the room (disposable at every room change).</li>
                    </ul>
                </p>

                <p>
                    <ul>
                        Some extra comforts for you:
                        <li>We guarantee self check-in with an access code and a magnetic card to give you the possibility to "contactless" access the B&B; </li>
                        <li> Room breakfast; packed breakfast or breakfast at the nice cafe downstairs located next to our entrance</li>
                        <li>We are digitilizing most of our services, including our assistance: you can contact us by call, WhatsApp, message for any need!</li>
                        <li>We guarantee self check-out: you can easily leave the property skipping check-out procedures at the reception desk.</li>
                    </ul>
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: { value: { required: true, default: false } },

    data: () => {
        return {

        }
    },

    methods: { getFlag(fileName) { return require(`../assets/${fileName}`); } }
}
</script>